"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageThreadType = exports.MessageHistoryType = void 0;
var MessageHistoryType;
(function (MessageHistoryType) {
    MessageHistoryType["USER_MESSAGE"] = "USER_MESSAGE";
    MessageHistoryType["AI_MESSAGE"] = "AI_MESSAGE";
    MessageHistoryType["NEW_THREAD"] = "NEW_THREAD";
    MessageHistoryType["TOOL_CALL"] = "TOOL_CALL";
    MessageHistoryType["TOOL_RESULT"] = "TOOL_RESULT";
})(MessageHistoryType || (exports.MessageHistoryType = MessageHistoryType = {}));
var MessageThreadType;
(function (MessageThreadType) {
    MessageThreadType["PERSONA"] = "PERSONA";
    MessageThreadType["EMPLOYEE"] = "EMPLOYEE";
    MessageThreadType["NONE"] = "NONE";
})(MessageThreadType || (exports.MessageThreadType = MessageThreadType = {}));
